import { useClient } from '../supabase/client'

import { useQuery } from '@tanstack/vue-query'

type Props = {
   userId?: string
   organizationId: string
   enabled?: boolean
}

export const useUserOrganization = (props: MaybeRef<Props>) => {
   const client = useClient()

   const query = useQuery({
      enabled: computed(() => toValue(props).enabled),
      queryKey: ['user-organization', props],
      queryFn: async () => {
         const query = client
            .schema('dashboard')
            .from('user_organization')
            .select(`*`)
            .eq('organization_id', toValue(props).organizationId)
            .throwOnError()

         if (toValue(props).userId) {
            query.eq('user_id', toValue(props).userId || '')
         }

         return (await query).data
      },
   })

   onServerPrefetch(async () => {
      if (toValue(props).enabled !== false) {
         await query.suspense()
      }
   })

   return query
}
